module.exports = __webpack_public_path__ + "img/HoveredSettingsIcon.a8488f66.svg";